var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ManagementPage", {
    attrs: { pageName: _vm.$t("FieldManagement") },
    scopedSlots: _vm._u([
      {
        key: "left",
        fn: function() {
          return [
            _c("TableView", {
              attrs: {
                "selected-object-uuid": _vm.selectedObject
                  ? _vm.selectedObject.uuid
                  : null
              },
              on: {
                "clear-selected-item": function($event) {
                  _vm.selectedObject = null
                },
                "update-selected-object": function($event) {
                  _vm.selectedObject = $event
                },
                "update-selected-object-type": function($event) {
                  _vm.selectedObjectType = $event
                }
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "right",
        fn: function() {
          return [
            _c("SelectedObject", {
              attrs: {
                "selected-object": _vm.selectedObject,
                "selected-object-type": _vm.selectedObjectType
              },
              on: {
                "clear-selected-item": function($event) {
                  _vm.selectedObject = null
                }
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d639909", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d639909","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TasksView.vue
// module id = null
// module chunks = 